var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { MediaPlayer } from '@dixa/lib-shared-habla';
import { isPrivateFilesAPI } from 'utils/api';
import { useAuthData } from 'utils/auth/authManager';
export const PrivateMediaPlayer = (_a) => {
    var props = __rest(_a, []);
    const authData = useAuthData();
    const hashToken = btoa(`token:${authData === null || authData === void 0 ? void 0 : authData.access_token}`);
    const headers = authData
        ? {
            Authorization: `Basic ${hashToken}`,
        }
        : {};
    const isPrivateFile = isPrivateFilesAPI(props.mediaFile.src || '');
    if (isPrivateFile && !authData) {
        return _jsx(_Fragment, {});
    }
    return (_jsx(MediaPlayer, Object.assign({}, props, { isPrivateFile: isPrivateFile, headers: headers })));
};
